import { render, staticRenderFns } from "./KgjtWebsiteProductEvolution.vue?vue&type=template&id=4ed61e16&scoped=true&"
import script from "./KgjtWebsiteProductEvolution.vue?vue&type=script&lang=js&"
export * from "./KgjtWebsiteProductEvolution.vue?vue&type=script&lang=js&"
import style0 from "./KgjtWebsiteProductEvolution.vue?vue&type=style&index=0&id=4ed61e16&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed61e16",
  null
  
)

export default component.exports